import moment from 'moment'

import { intervalToDuration } from 'date-fns'

export function getBinary(file: string) {
    let xhr = new XMLHttpRequest()
    xhr.open('GET', file, false)
    xhr.overrideMimeType('text/plain; charset=x-user-defined')
    xhr.send(null)
    return xhr.responseText
}

export function base64Encode(str: string) {
    const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
    let out = '',
        i = 0,
        len = str.length,
        c1,
        c2,
        c3
    while (i < len) {
        c1 = str.charCodeAt(i++) & 0xff
        if (i == len) {
            out += CHARS.charAt(c1 >> 2)
            out += CHARS.charAt((c1 & 0x3) << 4)
            out += '=='
            break
        }
        c2 = str.charCodeAt(i++)
        if (i == len) {
            out += CHARS.charAt(c1 >> 2)
            out += CHARS.charAt(((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4))
            out += CHARS.charAt((c2 & 0xf) << 2)
            out += '='
            break
        }
        c3 = str.charCodeAt(i++)
        out += CHARS.charAt(c1 >> 2)
        out += CHARS.charAt(((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4))
        out += CHARS.charAt(((c2 & 0xf) << 2) | ((c3 & 0xc0) >> 6))
        out += CHARS.charAt(c3 & 0x3f)
    }
    return out
}

export function checkZeroPrefixPhoneNumber(phoneNumber: string) {
    if (!phoneNumber.startsWith('233') && !phoneNumber.startsWith('+233') && !phoneNumber.startsWith('0')) {
        phoneNumber = '0' + phoneNumber
    }
    return phoneNumber
}

export function delayAsyncCall(props: { funcToBeCalled: () => Promise<void>; delay: number }): Promise<void> {
    const { funcToBeCalled, delay } = props
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            funcToBeCalled().then(resolve).catch(reject)
        }, delay)
    })
}

export function manageLocalStorage<T = string>({
    action,
    key,
    itemToSave,
}: {
    action: 'set' | 'get' | 'delete'
    key: string
    itemToSave?: T
}) {
    switch (action) {
        case 'get': {
            const item = localStorage.getItem(key)
            if (item === null) return null
            try {
                // Attempt to parse as JSON
                return JSON.parse(item) as T
            } catch (error) {
                // Return as string if JSON.parse fails
                return item as unknown as T
            }
        }

        case 'set':
            localStorage.setItem(key, JSON.stringify(itemToSave ?? ''))
            break

        case 'delete':
            localStorage.removeItem(key)
            break

        default:
            break
    }
}

export function getMonthFromDate(date: Date = new Date()) {
    const month = moment().month(moment(date).month()).format('MMMM')
    const year = moment().year(moment(date).year()).format('YYYY')
    return { month, year }
}

export function startTimer(milliseconds: number, timerId: any) {
    let seconds = Math.floor(milliseconds / 1000)
    let minutes = Math.floor(seconds / 60)
    seconds = seconds % 60

    if (seconds === 0) {
        if (minutes === 0) {
            return
        } else if (minutes !== 0) {
            minutes = minutes - 1
            seconds = 60
        }
    }

    seconds = seconds - 1

    const remainingTime = minutes * 60 * 1000 + seconds * 1000
    const newTimerId = setTimeout(function () {
        startTimer(minutes * 60 * 1000 + seconds * 1000, timerId)
    }, 1000)

    return {
        remainingTime,
        newTimerId,
    }
}

export function formatMilliseconds(ms: number): { minutes: string | number; seconds: string | number } {
    const minutes = Math.floor(ms / 60000) // 1 minute = 60000 milliseconds
    const seconds = Math.floor((ms % 60000) / 1000) // 1 second = 1000 milliseconds

    // Format minutes and seconds as two-digit strings
    // const formattedMinutes = minutes.toString().padStart(2, '0')
    const formattedSeconds = seconds.toString().padStart(2, '0')

    // Format minutes and seconds as a string
    return {
        minutes: minutes,
        seconds: formattedSeconds,
    }
}

export const formatSeconds = (seconds: number = 0): { minutes: string | number; seconds: string | number } => {
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = Math.floor(seconds % 60)

    // Format minutes and seconds as two-digit strings
    // const formattedMinutes = minutes.toString().padStart(2, '0')
    const formattedSeconds = remainingSeconds.toString().padStart(2, '0')
    return {
        minutes: minutes,
        seconds: formattedSeconds,
    }
}

export function getDurationBetweenDates({ date1, date2 }: { date1: Date; date2: Date }) {
    return intervalToDuration({ start: date1, end: date2 })
}

export function getDurationInSeconds({ date1, date2 }: { date1: Date; date2: Date }): number {
    const diffInMilliseconds = date2.getTime() - date1.getTime()
    const diffInSeconds = diffInMilliseconds / 1000
    return Math.abs(diffInSeconds)
}

export const calculateRemainingTimeFromNow = ({
    startTime = new Date(),
    duration = 5,
}: {
    startTime?: Date
    duration: number //in minutes
}) => {
    const TIMEOUT_DURATION_SECONDS = duration * 60 // minutes to seconds
    const currentTime = new Date()
    const elapsedTimeInSeconds = (currentTime.getTime() - new Date(startTime).getTime()) / 1000
    return Math.round(TIMEOUT_DURATION_SECONDS - elapsedTimeInSeconds)
}

export const stringToLowerCase = (status?: string | null): string => {
    return status?.toLowerCase() ?? ''
}

export function formatGhanaPostString(input: string): string {
    // Regular expression to check if the string is already in the format X[A-Z0-9]-XXX-XXXX
    const regex = /^[A-Z][A-Z0-9]-\d{3}-\d{4}$/

    // If the input already matches the format, return it as is
    if (regex.test(input)) {
        return input
    }

    // Ensure the input is exactly 9 characters long without hyphens
    if (input.length !== 9) {
        // throw new Error('Input must be exactly 9 characters long')
        return input
    }

    // Split the input string into parts and join with hyphens
    const formatted = `${input.slice(0, 2)}-${input.slice(2, 5)}-${input.slice(5)}`

    return formatted
}

export function getAxiosErrorMessage(error: any): string {
    if (error.response) {
        return error.response.data.message
    } else if (error.request) {
        return 'Network error'
    } else {
        return error.message
    }
}

export const isHtmlString = (str: string) => {
    const doc = new DOMParser().parseFromString(str, 'text/html')
    return Array.from(doc.body.childNodes).some(node => node.nodeType === 1)
}

// const isHtmlString = (str: string) => /<\/?[a-z][\s\S]*>/i.test(str)

export const asyncDelay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms))

export const roundToDecimalPlace = ({
    num,
    decimalPlace = 2,
    returnAsString = false,
}: {
    num: number | string
    decimalPlace?: number
    returnAsString?: boolean
}): number | string => {
    if (+num < 0) return -roundToDecimalPlace({ num: -num, decimalPlace })
    const p = Math.pow(10, decimalPlace)
    const n = +(+num * p).toPrecision(15)

    const value = Math.round(n) / p

    if (returnAsString) {
        return value.toLocaleString(undefined, {
            minimumFractionDigits: decimalPlace,
        })
    }
    return value
}

export const moveArrayElement = <T>(arr: T[], sourceIndex: number, destinationIndex: number): T[] => {
    if (sourceIndex < 0 || sourceIndex >= arr.length || destinationIndex < 0 || destinationIndex >= arr.length) {
        throw new Error('Invalid source or destination index')
    }

    const newArr = arr.slice()
    const element = newArr.splice(sourceIndex, 1)[0]

    newArr.splice(destinationIndex, 0, element)

    return newArr
}
